import script from "./BillCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./BillCellElementLite.vue?vue&type=style&index=0&id=3a4ba539&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4ba539"]])

export default __exports__